export default __webpack_public_path__ + "static/media/discharge.442ce011.png";